/**
 * Implement image upload handlers for template models.
 *
 * These are very similar to each other, but kept separate to allow
 * changing one without affecting the other.
 */

import API from '@/api';
import eventbus from '@/bus';

function getImageUploadParametersFromOverlayOptions(overlayOptions, fieldName) {
  const opts = {
    spritesheetWidth: null,
    spritesheetHeight: null,
    scaleWidth: null,
    scaleHeight: null,
  };

  if (
    overlayOptions &&
    overlayOptions.dynamic_fields &&
    overlayOptions.dynamic_fields.data
  ) {
    const data = overlayOptions.dynamic_fields.data;
    const field = data[fieldName];

    if (field.width && field.height) {
      if (field.crop_ratio && field.crop_ratio == 'any') {
        // TODO: It currently makes no sense to force arbitrary images
        //   into the original container dimensions, so skip resizing
        //   here. If we enable it we need to make sure we don't break
        //   old templates that use "crop_ratio": "any".
      } else {
        opts.scaleWidth = field.width;
        opts.scaleHeight = field.height;
      }
    }

    if (field.spritesheet_width && field.spritesheet_height) {
      opts.spritesheetWidth = field.spritesheet_width;
      opts.spritesheetHeight = field.spritesheet_height;
    }
  }

  return opts;
}

export function onTVTemplateImageReplacementCropped(
  tvtemplateId,
  overlayOptions,
  fieldName,
  file,
  originalFilename
) {
  // Toggle busy indicator on IMAGE interface.
  eventbus.$emit('set-overlay-data-image-field-busy', fieldName, true);

  const imageUploadParams = getImageUploadParametersFromOverlayOptions(
    overlayOptions,
    fieldName
  );

  API.uploadCroppedImageForUseInTVTemplate(
    tvtemplateId,
    file,
    originalFilename,
    imageUploadParams
  )
    .then((response) => {
      const uploadedImageUrl = response.data.image_url;
      console.log('[DEBUG] Replacement image URL:', uploadedImageUrl);

      // Since the OverlayDataField widgets can be somewhat nested, we
      // display our new image using a global signal.
      eventbus.$emit(
        'set-overlay-data-field-value',
        fieldName,
        uploadedImageUrl
      );
      eventbus.$emit('set-overlay-data-image-field-busy', fieldName, false);

      eventbus.$emit('alert-success', {
        message: 'tvtemplatesReplacementImageUploadSuccess',
        translate: true,
      });
    })
    .catch((error) => {
      console.error(error);

      eventbus.$emit('alert-error', {
        message: 'genericFailFeedback',
        translate: true,
      });
    });
}

export function onEditableTVSpotTemplateImageReplacementCropped(
  editableTemplateId,
  overlayOptions,
  fieldName,
  file,
  originalFilename
) {
  const imageUploadParams = getImageUploadParametersFromOverlayOptions(
    overlayOptions,
    fieldName
  );

  API.uploadCroppedImageForUseInEditableTVSpotTemplate(
    editableTemplateId,
    file,
    originalFilename,
    imageUploadParams
  )
    .then((response) => {
      const uploadedImageUrl = response.data.image_url;

      // Since the OverlayDataField widgets can be somewhat nested,
      // we the one responsible to display our new image using a
      // global signal.
      eventbus.$emit(
        'set-overlay-data-field-value',
        fieldName,
        uploadedImageUrl
      );

      eventbus.$emit('alert-success', {
        message: 'tvtemplatesReplacementImageUploadSuccess',
        translate: true,
      });
    })
    .catch((error) => {
      console.error(error);

      eventbus.$emit('alert-error', {
        message: 'genericFailFeedback',
        translate: true,
      });
    });
}



// WEBPACK FOOTER //
// ./src/mixins/imageReplacement.js